import { createSelector } from '@ngrx/store';
import {
  FEEDBACK,
  getAll,
  getEntities,
  MEMBERS,
  State as AppState,
  statistics,
  getSelected,
  ORGANISATIONS,
  org,
} from '../reducers/index';
import { FeedbackState } from './feedback.reducer';
import { OrganisationDto } from '@careapp-group/ng-sdk-v2-new';
export const getFeedbackState = (state: AppState) => state.auth;

export const feedbackWithMember = createSelector(
  getAll(FEEDBACK),
  getEntities(MEMBERS),
  statistics.getFilters,
  (feedback, staff) => {
    feedback = (feedback as any[]).sort((prev, next) => prev.created - next.created);
    return (<Array<any>>feedback).map((item) => ({
      ...item,
      member: staff[item.memberId],
    }));
  }
);

export const feedbackSlice = (state: { feedback: FeedbackState }) => state.feedback;

export const isSubmitting = createSelector(feedbackSlice, (slice) => slice.creating);

/**
 * Whether the user can post feedback in the current organisation.
 *
 * Users must have an org permission, and feedback must be
 * enabled for the organisation.
 */
export const userCanPostFeedback = createSelector(
  getSelected(ORGANISATIONS),
  org.currentOrgConfiguration,
  (org: OrganisationDto, config) => {
    return org?.permissions?.length > 0 && config?.feedbackEnabled;
  }
);
